import { ActionType } from "typesafe-actions";

import { ConversionPercentsValues } from "../../conversions/types";

import * as actions from "./actions";

export type ApiStateWidgetAction = ActionType<typeof actions>;

export enum ApiStateWidgetActionTypes {
  FETCH_REQUEST = "@ApiStateWidget/FETCH_REQUEST",
  FETCH_SUCCESS = "@ApiStateWidget/FETCH_SUCCESS",
  FETCH_ERROR = "@ApiStateWidget/FETCH_ERROR",
}

export interface ApiStateResponse extends ConversionPercentsValues {
  lastUpdate?: string;
}

export interface ApiStateWidgetState extends ApiStateResponse {
  readonly isLoading: boolean;
}
